import { useState } from "react";
import IconButton from '/src/components/UI/Button/IconButton/IconButton';
import './JsonFormatter.css';

export const formatJsonValue = (text) => {
    if (!text || typeof text !== 'string') {
        return { success: false, value: text };
    }

    const trimmed = text.trim();
    if (/^\[[^\]]+\]$/.test(trimmed)) {
        return { success: null, value: text };
    }

    const tryFormat = (str) => {
        const parsed = JSON.parse(str);
        return JSON.stringify(parsed, null, 2);
    };

    try {
        return {
            success: true,
            value: tryFormat(trimmed)
        };
    } catch (_) {
        try {
            const repaired = trimmed
                .replace(/,\s*}/g, '}')
                .replace(/,\s*]/g, ']');

            return {
                success: true,
                value: tryFormat(repaired)
            };
        } catch (_) {
            return {
                success: false,
                value: text
            };
        }
    }
};

function JsonFormatter({ onClick, status }) {
    return (
        <IconButton
            onClick={onClick}
            className={`editor_button main_add-button button_center json-format-button ${status === 'success' ? 'json-success' : status === 'error' ? 'json-error' : 'edit_action'}`}
            icon={status === 'success' ? 'fas fa-check' : status === 'error' ? 'fas fa-times' : 'fas fa-code'}
            title="Format JSON (Alt + Shift + F)"
        />
    );
}
          
JsonFormatter.defaultProps = {
    status: null,
    onClick: () => {}
};

export default JsonFormatter;
